import style from './ApplePayButton.module.css';
import { ApplePayIcon } from './ApplePayIcon';

interface ApplePayButtonProps {
    theme?: 'light' | 'dark';
    ariaLabel?: string;
    text?: string;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const ApplePayButton = ({
    theme = 'dark',
    ariaLabel = 'Pay with Apple Pay',
    text = 'Pay with',
    ...extraProps
}: ApplePayButtonProps) => {
    const isLightTheme = theme.toLowerCase() === 'light';

    return (
        <button
            className={`${style.applePayButton} ${style.applePayButtonTheme}${
                isLightTheme ? 'Light' : 'Dark'
            }}`}
            {...extraProps}
            aria-label={ariaLabel}
        >
            <div className={style.innerWrapper}>
                <span className={style.text}>{text}</span>
                <ApplePayIcon />
            </div>
        </button>
    );
};

export { ApplePayButton };
